import { render } from "./UpgradeKubernetesCluster.vue?vue&type=template&id=5c1741ab&scoped=true"
import script from "./UpgradeKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./UpgradeKubernetesCluster.vue?vue&type=script&lang=js"

import "./UpgradeKubernetesCluster.vue?vue&type=style&index=0&id=5c1741ab&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1741ab"]])

export default __exports__